import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr21 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        ЗА ЕЖЕДНЕВЕН ИНСТРУКТАЖ
      </Typography>
      <Typography variant="subtitle1" style={styles.title}>
        за временна организация и безопасност на движението /ВОБД/ при извършване на строителни и
        монтажни работи по пътищата и улиците
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        Ежедневният инструктаж се провежда от техническия ръководител или отговорника по ЗБУТ в
        началото на всяка работна смяна и отнема не повече от 5-10 минути, фокусирайки се върху
        конкретните условия на деня.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Анализ на метеорологичните условия и видимостта</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1.1. Дъжд, мъгла или снеговалеж: </b>Инструкторът оценява спирачния път на автомобилите.
        При намалена видимост (под 50 метра) скоростта на движение в зоната се ограничава
        допълнително, а конусите се поставят на по-гъсти интервали.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1.2. Хлъзгав път / Слънчево заслепяване: </b>Напомня се на регулировчиците да отчитат
        факта, че шофьорите могат да бъдат заслепени от слънцето или да нямат възможност да спрат
        бързо поради мокра настилка.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Специфика на трафика за деня</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        Проверява се дали през деня се очаква повишен интензитет на движението (напр. петък
        следобед, празнични дни, преминаване на извънгабаритни товари). При засилен трафик на
        четирилентови пътища се изисква повишено внимание при работа в близост до разделителната
        линия.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Разпределение на постовете и задачите</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3.1. </b>Ясно се посочват имената на служителите, които ще извършват монтаж/демонтаж, и
        тези, които ще регулират движението (Пост №1 - Начало, Пост №2 - Край).
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3.2. </b>Тества се изправността на радиостанциите и се проверява зарядът на батериите им
        преди излизане на пътя.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. Авариен план и евакуация при критична ситуация</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4.1. Сигнал за опасност: </b>При установяване на приближаващ автомобил, който се движи с
        несъобразена скорост, криволичи или не реагира на сигналите за спиране, регулировчикът/
        работникът подава продължителен и остър сигнал със свирка.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4.2. Път за бягство: </b>Всеки служител на пътното платно е длъжен предварително (още в
        началото на смяната) да огледа терена и да знае своя &quot;път за бягство&quot; – накъде да
        отскочи при опасност (зад еластична оградна бариера, в канавката, извън банкета).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b style={styles.warning}>Забрана!: </b>Никога не се прави опит за физическо спиране или
        препречване на пътя на нарушител. Собственият живот е с най-висок приоритет.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>Забележка: </b>С подписа си служителят удостоверява, че е запознат с рисковете на
        обекта, получил е пълна екипировка (ЛПС) и е разбрал аварийния план за евакуация при
        опасност на пътното платно.
      </Typography>

      <Typography style={styles.date}>
        <b>27.08.2026г.</b>
      </Typography>
    </div>
  );
};
export default Instr21;
